// import { yupResolver } from "@hookform/resolvers/yup";
// import React, { useEffect, useState } from "react";
// import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
// import { FormProvider, useForm } from "react-hook-form";
// import * as yup from "yup";

// import { useLocation, useNavigate } from "react-router-dom";
// // import { customSettings } from "utils/customConfig";
// import { ProductsAPI, ProductsPostAPI } from "api";
// import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import { ProductSchema } from "schemas/ProductSchema";
// import { customSettings } from "utils/customConfig";
// import PageTitle from "utils/PageTitle";
// import Details from "./details/Details";
// import ProductGeneralInfo from "./general-info/ProductGeneralInfo";
// import MediaInfo from "./media-info/MediaInfo";
// import PricingAndStockInfoV3 from "./pricing-and-stock/PricingAndStockInfoV3";
// import RelatedProducts from "./related-products/RelatedProducts";
// import SocialPlatforms from "./social-platforms/SocialPlatforms";
// import ShippingAndWarrantyInfo from "./shipping-and-warranty/ShippingAndWarrantyInfo";
// import Specifications from "./specifications/Specifications";
// import Variants from "./variants/Variants";
// import {
//   mapApiVariantsToUI,
//   mapUIVariantsToApi,
// } from "../../../utils/functions";
// import Promotions from "./promotions/Promotions";

// const AddProduct = () => {
//   const { t } = useTranslation();
//   const [key, setKey] = useState("basicInfo");
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const submittedValues = {};
//   const methods = useForm({
//     resolver: yupResolver(ProductSchema),
//     defaultValues: {
//       name: "",
//       categoryId: "",
//       description: "",
//       highlights: "",
//       insideBox: "",
//       type: "",
//       tags: "",
//       salesPrice: 0,
//       cost: 0,
//       status: true,
//       mediaInfos: [],
//       specifications: [],
//       relatedProducts: [],
//       productPromotions: [],
//       productSocialLinks: [],
//       weight: 0,
//       weightUOM: "kg",
//       length: 0,
//       width: 0,
//       height: 0,
//       volumeUOM: "cm",
//       warranty: "",
//       warrantyType: "",
//       warrantyPolicy: "",
//     },
//     shouldUnregister: false,
//   });
//   const { handleSubmit, reset, setValue } = methods;

//   const onSubmit = async (data) => {
//     console.log("data", data);

//     let updatedSocialPlatforms = data?.productSocialLinks.map((sc) => ({
//       ...sc,
//       socialPlatformId: sc.socialPlatformId || "0",
//       url: sc.url || "",
//     }));
//     let updatedProductPromotions = data?.productPromotions.map((product) => ({
//       ...product,
//       promotionId: product.promotionId || "0", // Set to "0" if it's undefined or empty
//     }));
//     let updatedRelatedProducts = data?.relatedProducts.map((product) => ({
//       ...product,
//       relatedProductId: product.relatedProductId || "0", // Set to "0" if it's undefined or empty
//     }));
//     let updatedMediaInfos = data?.mediaInfos.map((media) => ({
//       ...media,
//       contentType: media.contentType || "",
//       mediaInfo: media.mediaInfo || "",
//     }));

//     let pricingAndStocks = data?.pricingAndStocks?.map((p) => ({
//       ...p,
//       originalPrice: p.originalPrice ? p.originalPrice : 0,
//       // originalPrice:
//       //   p.originalPrice === "" ||
//       //     p.originalPrice === 0 ||
//       //     p.originalPrice === null ||
//       //     p.originalPrice === undefined
//       //     ? p.discountedPrice
//       //     : p.originalPrice,
//       discountedPrice: p.discountedPrice ? p.discountedPrice : 0,
//       skuCode: p.skuCode ? p.skuCode : "",
//       quantity: p.quantity ? p.quantity : 0,
//     }));

//     let productVariants = mapUIVariantsToApi(data?.productVariants);
//     // console.log(data);
//     let myData = {
//       ...data,
//       id: location?.state ? location?.state?.id : 0,
//       tags: data.tags.join("|"),
//       mediaInfos: updatedMediaInfos || [],
//       relatedProducts: updatedRelatedProducts || [],
//       pricingAndStocks: pricingAndStocks || [],
//       productVariants: productVariants || [],
//       productPromotions: updatedProductPromotions || [],
//       productSocialLinks: updatedSocialPlatforms || [],
//       volumeUOM: data?.volumeUOM ? data.volumeUOM : "cm",
//       weightUOM: data?.weightUOM ? data.weightUOM : "kg",
//     };
//     console.log("myData", myData);
//     try {
//       if (location?.state) {
//         setIsLoading(true);
//         await ProductsPostAPI.post(myData);
//         setIsLoading(false);
//         toast.success("Product Updated Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//           theme: "light",
//         });
//       } else {
//         setIsLoading(true);
//         await ProductsPostAPI.post(myData);
//         setIsLoading(false);
//         toast.success("Product Created Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//           theme: "light",
//         });
//       }
//       // ------- Get all object keys form data and set empty values to reset ------------
//       const keys = Object.keys(data);
//       for (const key of keys) {
//         submittedValues[key] = "";
//       }
//       reset({ ...submittedValues });
//       navigate(-1);
//     } catch (error) {
//       toast.error("Something Went Wrong", {
//         position: customSettings.toastPosition,
//         autoClose: customSettings.toastClose,
//       });
//       console.log(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (location.state) {
//       // console.log(mapApiVariantsToUI(location.state?.productVariants))

//       reset({
//         ...location.state,
//         productVariants: mapApiVariantsToUI(location.state?.productVariants),
//       });
//       // reset(location.state);
//     }
//   }, [location.state, reset]);

//   // if (isLoading) {
//   //   return (
//   //     <div
//   //       className="d-flex justify-content-center align-items-center"
//   //       style={{
//   //         position: "fixed",
//   //         top: 0,
//   //         left: 0,
//   //         width: "100vw",
//   //         height: "100vh",
//   //         backgroundColor: "rgba(0, 0, 0, 0.5)", // Backdrop effect
//   //         zIndex: 9999, // Ensure it's above other content
//   //       }}
//   //     >
//   //       <Spinner variant="primary" animation="border" />
//   //     </div>
//   //   );
//   // }

//   return (
//     <>
//       {/* <div className="py-2">
//         <BreadCrumb />
//       </div> */}

//       <PageTitle name="Products" />

//       <FormProvider {...methods}>
//         <Form onSubmit={handleSubmit(onSubmit)}>
//           <Card>
//             <Card.Header className="border-bottom">
//               <Row className="flex-between-center shadow-none ">
//                 <Col md>
//                   {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                     {" "}
//                     Products | Manage Products
//                   </h5> */}
//                   <BreadCrumbTable
//                     title="Products"
//                     subTitle={location?.state?.name}
//                   />
//                 </Col>
//                 <Col xs="auto">
//                   <Button
//                     variant="link"
//                     className="text-secondary fw-medium p-0 me-3"
//                     type="button"
//                     onClick={() => navigate(-1)}
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     // disabled={isLoading}
//                     variant="primary"
//                     type="submit"
//                   >
//                     {/* {isLoading ? "Submitting.." : "Ok"} */}
//                     Ok
//                   </Button>
//                 </Col>
//               </Row>
//             </Card.Header>

//             <div
//               className="mb-3 py-2"
//               style={{
//                 height: `calc(100vh - 8.4rem)`,
//                 overflow: "auto",
//               }}
//             >
//               {/* <Card.Header>
//                   <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
//                     Inventory
//                   </h5>
//                 </Card.Header> */}
//               <Tabs
//                 id="controlled-tab-example"
//                 activeKey={key}
//                 onSelect={(k) => setKey(k)}
//               >
//                 <Tab eventKey="basicInfo" title={t("general")} className="p-3 ">
//                   <ProductGeneralInfo />
//                 </Tab>
//                 <Tab eventKey="mediaInfo" title={t("gallery")} className="p-3 ">
//                   <MediaInfo />
//                 </Tab>
//                 <Tab
//                   eventKey="specification"
//                   title={t("specification")}
//                   className="p-3 "
//                 >
//                   <Specifications />
//                 </Tab>
//                 <Tab eventKey="variants" title={t("variants")} className="p-3 ">
//                   <Variants />
//                 </Tab>
//                 <Tab
//                   eventKey="pricingAndStock"
//                   title={t("pricingAndStock")}
//                   className="p-3 "
//                 >
//                   {/* <PricingAndStockInfo /> */}
//                   <PricingAndStockInfoV3 />
//                 </Tab>
//                 <Tab
//                   eventKey="promotions"
//                   title={t("promotions")}
//                   className="p-3 "
//                 >
//                   <Promotions />
//                 </Tab>
//                 <Tab
//                   eventKey="socialPlatforms"
//                   title={t("socialPlatforms")}
//                   className="p-3 "
//                 >
//                   <SocialPlatforms />
//                 </Tab>

//                 <Tab eventKey="detail" title={t("details")} className="p-3 ">
//                   <Details />
//                 </Tab>
//                 <Tab
//                   eventKey="shippingAndWarranty"
//                   title={t("shippingAndWarranty")}
//                   className="p-3 "
//                 >
//                   <ShippingAndWarrantyInfo />
//                 </Tab>
//                 <Tab
//                   eventKey="relatedProducts"
//                   title={t("relatedProduct")}
//                   className="p-3 "
//                 >
//                   <RelatedProducts />
//                 </Tab>
//               </Tabs>
//             </div>
//           </Card>
//         </Form>
//       </FormProvider>
//     </>
//   );
// };

// export default AddProduct;

// import { yupResolver } from "@hookform/resolvers/yup";
// import React, { useEffect, useRef, useState } from "react";
// import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
// import { FormProvider, useForm } from "react-hook-form";

// import { useLocation, useNavigate } from "react-router-dom";
// // import { customSettings } from "utils/customConfig";
// import { ProductsPostAPI } from "api";
// import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import { ProductSchema } from "schemas/ProductSchema";
// import { customSettings } from "utils/customConfig";
// import PageTitle from "utils/PageTitle";
// import {
//   mapApiVariantsToUI,
//   mapUIVariantsToApi,
// } from "../../../utils/functions";
// import Details from "./details/Details";
// import ProductGeneralInfo from "./general-info/ProductGeneralInfo";
// import MediaInfo from "./media-info/MediaInfo";
// import PricingAndStockInfoV3 from "./pricing-and-stock/PricingAndStockInfoV3";
// import Promotions from "./promotions/Promotions";
// import RelatedProducts from "./related-products/RelatedProducts";
// import ShippingAndWarrantyInfo from "./shipping-and-warranty/ShippingAndWarrantyInfo";
// import SocialPlatforms from "./social-platforms/SocialPlatforms";
// import Specifications from "./specifications/Specifications";
// import Variants from "./variants/Variants";

// const TAB_FIELDS = {
//   basicInfo: [
//     "name",
//     "categoryId",
//     "type",
//     "tags",
//     "salesPrice",
//     "cost",
//   ],
//   mediaInfo: ["mediaInfos"],
//   specification: ["specifications"],
//   variants: ["productVariants"],
//   pricingAndStock: ["pricingAndStocks"],
//   promotions: ["productPromotions"],
//   socialPlatforms: ["productSocialLinks"],
//   detail: ["description", "highlights", "insideBox"],
//   shippingAndWarranty: [
//     "weight",
//     "weightUOM",
//     "length",
//     "width",
//     "height",
//     "warranty",
//     "warrantyType",
//   ],
//   relatedProducts: ["relatedProducts"],
// };

// const AddProduct = () => {
//   const { t } = useTranslation();
//   const [key, setKey] = useState("basicInfo");
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const errorTabIndexRef = useRef(0);

//   const submittedValues = {};
//   const methods = useForm({
//     resolver: yupResolver(ProductSchema),
//     defaultValues: {
//       name: "",
//       categoryId: "",
//       description: "",
//       highlights: "",
//       insideBox: "",
//       type: "",
//       tags: "",
//       salesPrice: 0,
//       cost: 0,
//       status: true,
//       mediaInfos: [],
//       specifications: [],
//       relatedProducts: [],
//       productPromotions: [],
//       productSocialLinks: [],
//       weight: 0,
//       weightUOM: "kg",
//       length: 0,
//       width: 0,
//       height: 0,
//       volumeUOM: "cm",
//       warranty: "",
//       warrantyType: "",
//       warrantyPolicy: "",
//     },
//     shouldUnregister: false,
//   });
//   const { handleSubmit, reset, setValue, formState: { errors } } = methods;

//   const getErrorTabs = (errors) => {
//     return Object.entries(TAB_FIELDS)
//       .filter(([_, fields]) =>
//         fields.some((field) => errors?.[field])
//       )
//       .map(([tabKey]) => tabKey);
//   };

//   useEffect(() => {
//     errorTabIndexRef.current = 0;
//   }, [Object.keys(errors).length]);

//   const onSubmit = async (data) => {
//     console.log("data", data);

//     let updatedSocialPlatforms = data?.productSocialLinks.map((sc) => ({
//       ...sc,
//       socialPlatformId: sc.socialPlatformId || "0",
//       url: sc.url || "",
//     }));
//     let updatedProductPromotions = data?.productPromotions.map((product) => ({
//       ...product,
//       promotionId: product.promotionId || "0", // Set to "0" if it's undefined or empty
//     }));
//     let updatedRelatedProducts = data?.relatedProducts.map((product) => ({
//       ...product,
//       relatedProductId: product.relatedProductId || "0", // Set to "0" if it's undefined or empty
//     }));
//     let updatedMediaInfos = data?.mediaInfos.map((media) => ({
//       ...media,
//       contentType: media.contentType || "",
//       mediaInfo: media.mediaInfo || "",
//     }));

//     let pricingAndStocks = data?.pricingAndStocks?.map((p) => ({
//       ...p,
//       originalPrice: p.originalPrice ? p.originalPrice : 0,
//       discountedPrice: p.discountedPrice ? p.discountedPrice : 0,
//       skuCode: p.skuCode ? p.skuCode : "",
//       quantity: p.quantity ? p.quantity : 0,
//     }));

//     let productVariants = mapUIVariantsToApi(data?.productVariants);
//     // console.log(data);
//     let myData = {
//       ...data,
//       id: location?.state ? location?.state?.id : 0,
//       tags: data.tags.join("|"),
//       mediaInfos: updatedMediaInfos || [],
//       relatedProducts: updatedRelatedProducts || [],
//       pricingAndStocks: pricingAndStocks || [],
//       productVariants: productVariants || [],
//       productPromotions: updatedProductPromotions || [],
//       productSocialLinks: updatedSocialPlatforms || [],
//       volumeUOM: data?.volumeUOM ? data.volumeUOM : "cm",
//       weightUOM: data?.weightUOM ? data.weightUOM : "kg",
//     };
//     console.log("myData", myData);
//     try {
//       if (location?.state) {
//         setIsLoading(true);
//         await ProductsPostAPI.post(myData);
//         setIsLoading(false);
//         toast.success("Product Updated Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//           theme: "light",
//         });
//       } else {
//         setIsLoading(true);
//         await ProductsPostAPI.post(myData);
//         setIsLoading(false);
//         toast.success("Product Created Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//           theme: "light",
//         });
//       }
//       // ------- Get all object keys form data and set empty values to reset ------------
//       const keys = Object.keys(data);
//       for (const key of keys) {
//         submittedValues[key] = "";
//       }
//       reset({ ...submittedValues });
//       navigate(-1);
//     } catch (error) {
//       toast.error("Something Went Wrong", {
//         position: customSettings.toastPosition,
//         autoClose: customSettings.toastClose,
//       });
//       console.log(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const onInvalid = (errors) => {
//     const tabsWithErrors = getErrorTabs(errors);

//     if (!tabsWithErrors.length) return;

//     const index = errorTabIndexRef.current;

//     setKey(tabsWithErrors[index]); // 👈 MOVE ON FIRST CLICK

//     errorTabIndexRef.current =
//       index + 1 < tabsWithErrors.length ? index + 1 : 0;
//   };

//   useEffect(() => {
//     if (location.state) {
//       // console.log(mapApiVariantsToUI(location.state?.productVariants))

//       reset({
//         ...location.state,
//         productVariants: mapApiVariantsToUI(location.state?.productVariants),
//       });
//       // reset(location.state);
//     }
//   }, [location.state, reset]);

//   const tabTitle = (label, tabKey) => {
//     const hasError = TAB_FIELDS[tabKey]?.some(
//       (field) => errors?.[field]
//     );

//     return (
//       <span
//         className={`d-flex align-items-center gap-1 ${hasError ? "text-danger fw-semibold" : ""
//           }`}
//       >
//         {label}
//         {hasError && <span>⚠</span>}
//       </span>
//     );
//   };

//   return (
//     <>
//       {/* <div className="py-2">
//         <BreadCrumb />
//       </div> */}

//       <PageTitle name="Products" />

//       <FormProvider {...methods}>
//         <Form onSubmit={handleSubmit(onSubmit, onInvalid)}>
//           <Card>
//             <Card.Header className="border-bottom">
//               <Row className="flex-between-center shadow-none ">
//                 <Col md>
//                   {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                     {" "}
//                     Products | Manage Products
//                   </h5> */}
//                   <BreadCrumbTable
//                     title="Products"
//                     subTitle={location?.state?.name}
//                   />
//                 </Col>
//                 <Col xs="auto">
//                   <Button
//                     variant="link"
//                     className="text-secondary fw-medium p-0 me-3"
//                     type="button"
//                     onClick={() => navigate(-1)}
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     // disabled={isLoading}
//                     variant="primary"
//                     type="submit"
//                   >
//                     {/* {isLoading ? "Submitting.." : "Ok"} */}
//                     Ok
//                   </Button>
//                 </Col>
//               </Row>
//             </Card.Header>

//             <div
//               className="mb-3 py-2"
//               style={{
//                 height: `calc(100vh - 8.4rem)`,
//                 overflow: "auto",
//               }}
//             >
//               <Tabs activeKey={key} onSelect={(k) => setKey(k)}>
//                 <Tab
//                   eventKey="basicInfo"
//                   title={tabTitle(t("general"), "basicInfo")}
//                   className="p-3"
//                 >
//                   <ProductGeneralInfo />
//                 </Tab>

//                 <Tab
//                   eventKey="mediaInfo"
//                   title={tabTitle(t("gallery"), "mediaInfo")}
//                   className="p-3"
//                 >
//                   <MediaInfo />
//                 </Tab>

//                 <Tab
//                   eventKey="specification"
//                   title={tabTitle(t("specification"), "specification")}
//                   className="p-3"
//                 >
//                   <Specifications />
//                 </Tab>

//                 <Tab
//                   eventKey="variants"
//                   title={tabTitle(t("variants"), "variants")}
//                   className="p-3"
//                 >
//                   <Variants />
//                 </Tab>

//                 <Tab
//                   eventKey="pricingAndStock"
//                   title={tabTitle(t("pricingAndStock"), "pricingAndStock")}
//                   className="p-3"
//                 >
//                   <PricingAndStockInfoV3 />
//                 </Tab>

//                 <Tab
//                   eventKey="promotions"
//                   title={tabTitle(t("promotions"), "promotions")}
//                   className="p-3"
//                 >
//                   <Promotions />
//                 </Tab>

//                 <Tab
//                   eventKey="socialPlatforms"
//                   title={tabTitle(t("socialPlatforms"), "socialPlatforms")}
//                   className="p-3"
//                 >
//                   <SocialPlatforms />
//                 </Tab>

//                 <Tab
//                   eventKey="detail"
//                   title={tabTitle(t("details"), "detail")}
//                   className="p-3"
//                 >
//                   <Details />
//                 </Tab>

//                 <Tab
//                   eventKey="shippingAndWarranty"
//                   title={tabTitle(t("shippingAndWarranty"), "shippingAndWarranty")}
//                   className="p-3"
//                 >
//                   <ShippingAndWarrantyInfo />
//                 </Tab>

//                 <Tab
//                   eventKey="relatedProducts"
//                   title={tabTitle(t("relatedProduct"), "relatedProducts")}
//                   className="p-3"
//                 >
//                   <RelatedProducts />
//                 </Tab>
//               </Tabs>

//             </div>
//           </Card>
//         </Form>
//       </FormProvider>
//     </>
//   );
// };

// export default AddProduct;

import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ProductsPostAPI } from "api";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import { useTranslation } from "react-i18next";
import { ProductSchema } from "schemas/ProductSchema";
import { customSettings } from "utils/customConfig";
import PageTitle from "utils/PageTitle";
import {
  cleanHtml,
  mapApiVariantsToUI,
  mapUIVariantsToApi,
} from "../../../utils/functions";

// Import your tab components
import Details from "./details/Details";
import ProductGeneralInfo from "./general-info/ProductGeneralInfo";
import MediaInfoV1 from "./media-info/MediaInfoV1";
import PricingAndStockInfoV3 from "./pricing-and-stock/PricingAndStockInfoV3";
import Promotions from "./promotions/Promotions";
import RelatedProducts from "./related-products/RelatedProducts";
import ShippingAndWarrantyInfo from "./shipping-and-warranty/ShippingAndWarrantyInfo";
import SocialPlatforms from "./social-platforms/SocialPlatforms";
import Specifications from "./specifications/Specifications";
import Variants from "./variants/Variants";
import CustomizationPrice from "./customization-price/CustomizationPrice";
import MetaInformation from "./meta-information/MetaInformation";

// Define fields associated with each tab
const TAB_FIELDS = {
  basicInfo: ["name", "categoryId", "type", "tags", "salesPrice", "cost"],
  mediaInfo: ["mediaInfos"],
  specification: ["specifications"],
  variants: ["productVariants"],
  pricingAndStock: ["pricingAndStocks"],
  promotions: ["productPromotions"],
  socialPlatforms: ["productSocialLinks"],
  detail: ["description", "highlights", "insideBox"],
  shippingAndWarranty: [
    "weight",
    "weightUOM",
    "length",
    "width",
    "height",
    "warranty",
    "warrantyType",
  ],
  relatedProducts: ["relatedProducts"],
  customizationPrice: ["customizationPrice"],
};

const AddProduct = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState("basicInfo");
  const navigate = useNavigate();
  const location = useLocation();
  const errorTabIndexRef = useRef(0);

  // Initialize form
  const methods = useForm({
    resolver: yupResolver(ProductSchema),
    defaultValues: {
      name: "",
      categoryId: "",
      description: "",
      highlights: "",
      insideBox: "",
      type: "",
      tags: [],
      salesPrice: "",
      cost: "",
      status: true,
      mediaInfos: [],
      specifications: [],
      relatedProducts: [],
      productPromotions: [],
      productSocialLinks: [],
      weight: 0,
      weightUOM: "kg",
      length: 0,
      currentStock: "",
      width: 0,
      height: 0,
      volumeUOM: "cm",
      warranty: "",
      warrantyType: "",
      warrantyPolicy: "",
      productVariants: location.state?.productVariants
        ? mapApiVariantsToUI(location.state.productVariants)
        : [],
      pricingAndStocks: [],
    },
    shouldUnregister: false,
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { errors, isSubmitting },
  } = methods;

  const customizationId = watch("customizationId");
  const isCustomizable = watch("isCustomizable");

  // Compute tabs with errors
  const errorTabs = React.useMemo(() => {
    return Object.entries(TAB_FIELDS)
      .filter(([_, fields]) => fields.some((field) => errors?.[field]))
      .map(([tabKey]) => tabKey);
  }, [errors]);

  // Reset error index if errorTabs length changes
  useEffect(() => {
    errorTabIndexRef.current = 0;
  }, [errorTabs.length]);

  // Move to first error tab on invalid submit
  const onInvalid = () => {
    if (!errorTabs.length) return;

    const index = errorTabIndexRef.current;
    setKey(errorTabs[index]);

    errorTabIndexRef.current = index + 1 < errorTabs.length ? index + 1 : 0;
  };

  const buildOiMappingString = (mappingObj) => {
    if (!mappingObj) return "";

    return Object.entries(mappingObj)
      .filter(([key, value]) => key && value)
      .map(([key, value]) => `${key}=${value}`)
      .join("|");
  };

  // Map UI variants to API format
  const mapDataForApi = (data) => {
    let updatedSocialPlatforms = data.productSocialLinks.map((sc) => ({
      ...sc,
      socialPlatformId: sc.socialPlatformId || "0",
      url: sc.url || "",
    }));

    let updatedProductPromotions = data.productPromotions.map((p) => ({
      ...p,
      promotionId: p.promotionId || "0",
    }));

    let updatedRelatedProducts = data.relatedProducts.map((p) => ({
      ...p,
      relatedProductId: p.relatedProductId || "0",
    }));

    let updatedMediaInfos = data.mediaInfos.map((m) => ({
      ...m,
      contentType: m.contentType || "",
      mediaInfo: m.mediaInfo || "",
    }));

    let pricingAndStocks = data.pricingAndStocks.map((p) => ({
      ...p,
      originalPrice: p.originalPrice || 0,
      discountedPrice: p.discountedPrice || 0,
      skuCode: p.skuCode || "",
      quantity: p.quantity || 0,
    }));

    console.log("data.updatedRelatedProducts", data.updatedRelatedProducts);

    return {
      ...data,
      id: location?.state?.id || 0,
      tags: data.tags.join("|"),
      mediaInfos: updatedMediaInfos,
      relatedProducts: updatedRelatedProducts,
      pricingAndStocks,
      productVariants: Array.isArray(data.productVariants)
        ? mapUIVariantsToApi(data.productVariants)
        : [],
      productPromotions: updatedProductPromotions,
      productSocialLinks: updatedSocialPlatforms,
      volumeUOM: data.volumeUOM || "cm",
      weightUOM: data.weightUOM || "kg",
      customizationId: data.isCustomizable ? data.customizationId || 0 : 0,
      insideBox: cleanHtml(data.insideBox),
      highlights: cleanHtml(data.highlights),
      description: cleanHtml(data.description),
      currentStock: data?.currentStock ?? 0,
    };
  };

  const onSubmit = async (data) => {
    // console.log(data);

    const myData = mapDataForApi(data);

    console.log(myData);

    try {
      await ProductsPostAPI.post(myData);
      toast.success(
        location?.state
          ? "Product updated successfully"
          : "Product created successfully",
        {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        },
      );

      reset(); // reset form
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.error(error);
    }
  };

  // Load edit data
  useEffect(() => {
    if (location.state) {
      // console.log("location.state", location?.state);
      reset({
        ...location.state,
        relatedProducts:
          location?.state?.relatedProducts?.map((item) => ({
            ...item,
            relatedProductId: item.id,
          })) || [],
        productVariants: mapApiVariantsToUI(location.state.productVariants),
      });
    }
  }, [location.state, reset]);

  // Tab title with error indicator
  const tabTitle = (label, tabKey) => {
    const hasError = errorTabs.includes(tabKey);
    return (
      <span
        className={`d-flex align-items-center gap-1 ${
          hasError ? "text-danger fw-semibold" : ""
        }`}
      >
        {label}
        {/* {hasError && <span>⚠</span>} */}
      </span>
    );
  };

  return (
    <>
      <PageTitle name="Products" />
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit, onInvalid)}>
          <Card>
            {/* <Card.Header className="border-bottom">
              <Row className="flex-between-center shadow-none">
                <Col md>
                  <BreadCrumbTable
                    title="Products"
                    subTitle={location?.state?.name}
                  />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Ok" : "Ok"}
                  </Button>
                </Col>
              </Row>
            </Card.Header> */}

            <Card.Header className="border-bottom">
              <Row className="align-items-center">
                {/* LEFT SIDE */}
                <Col className="min-w-0">
                  <BreadCrumbTable
                    title="Products"
                    subTitle={location?.state?.name}
                  />
                </Col>

                {/* RIGHT SIDE */}
                <Col xs="auto" className="flex-shrink-0">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>

            <div
              // className="py-2 mb-3"
              style={{
                height: `calc(100vh - 8.4rem)`,
                overflow: "auto",
              }}
            >
              <Tabs activeKey={key} onSelect={setKey} unmountOnExit={false}>
                <Tab
                  eventKey="basicInfo"
                  title={tabTitle(t("general"), "basicInfo")}
                  className="p-3"
                >
                  <ProductGeneralInfo />
                </Tab>
                <Tab
                  eventKey="mediaInfo"
                  title={tabTitle(t("gallery"), "mediaInfo")}
                  className="p-3"
                >
                  <MediaInfoV1 />
                </Tab>
                <Tab
                  eventKey="specification"
                  title={tabTitle(t("specification"), "specification")}
                  className="p-3"
                >
                  <Specifications />
                </Tab>
                <Tab
                  eventKey="variants"
                  title={tabTitle(t("variants"), "variants")}
                  className="p-3"
                >
                  <Variants />
                </Tab>
                <Tab
                  eventKey="pricingAndStock"
                  title={tabTitle(t("pricingAndStock"), "pricingAndStock")}
                  className="p-3"
                >
                  <PricingAndStockInfoV3 />
                </Tab>
                <Tab
                  eventKey="promotions"
                  title={tabTitle(t("promotions"), "promotions")}
                  className="p-3"
                >
                  <Promotions />
                </Tab>
                <Tab
                  eventKey="socialPlatforms"
                  title={tabTitle(t("socialPlatforms"), "socialPlatforms")}
                  className="p-3"
                >
                  <SocialPlatforms />
                </Tab>
                <Tab
                  eventKey="detail"
                  title={tabTitle(t("details"), "detail")}
                  className="p-3"
                >
                  <Details />
                </Tab>
                <Tab
                  eventKey="shippingAndWarranty"
                  title={tabTitle(
                    t("shippingAndWarranty"),
                    "shippingAndWarranty",
                  )}
                  className="p-3"
                >
                  <ShippingAndWarrantyInfo />
                </Tab>
                <Tab
                  eventKey="relatedProducts"
                  title={tabTitle(t("relatedProduct"), "relatedProducts")}
                  className="p-3"
                >
                  <RelatedProducts />
                </Tab>
                <Tab
                  eventKey="metaInformation"
                  title={tabTitle(t("metaInformation"), "metaInformation")}
                  className="p-3"
                >
                  <MetaInformation />
                </Tab>
                <Tab
                  eventKey="customizationPrice"
                  title={tabTitle(
                    t("customizationPrice"),
                    "customizationPrice",
                  )}
                  className="p-3"
                  tabClassName={
                    customizationId && isCustomizable ? "" : "d-none"
                  }
                >
                  <CustomizationPrice />
                </Tab>
              </Tabs>
            </div>
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddProduct;
